// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { reduxForm } from 'redux-form'
import { antennaDatabaseSearchValidate } from 'validators/databaseSearches'

import {
  AdvancedSearchWrapper,
  Pagination,
} from '../common'

import {
  AdvancedSearch,
  BasicSearch,
} from './components'

const Form = ({ change, error, exportResults, form, handleSubmit, hasResults, reset }) => (
  <form
    id={form}
    className={'padding-left-1 padding-right-1 padding-bottom-half heading-font'}
    onSubmit={handleSubmit}>
    {
      error &&
      <p
        className={'width-100 bg-red margin-top-half'}
        id={`${form}-error`}>
        {error}
      </p>
    }
    <BasicSearch
      change={change}
      exportResults={exportResults}
      idRoot={`${form}-`}
      hasResults={hasResults}
      sourceForm={form} />
    <AdvancedSearchWrapper
      AdvancedSearch={AdvancedSearch}
      change={change}
      idRoot={`${form}-`}
      sourceForm={form}
      staticLabel={'Advanced Search'} />
    <div className={'padding-top-1'}>
      <Pagination
        idRoot={`${form}-`}
        sourceForm={form} />
    </div>
  </form>
)

Form.propTypes = {
  change: func.isRequired,
  error: string,
  exportResults: func.isRequired,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  hasResults: bool.isRequired,
  reset: func.isRequired,
}

const { asyncValidate, validate } = antennaDatabaseSearchValidate

export default reduxForm({
  asyncBlurFields: [
    'companyName',
  ],
  asyncValidate,
  destroyOnUnmount: false, // allows for previous search results to be displayed automagically
  validate,
})(Form)
